import React, { useState } from "react";

import { Button, Modal } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import { useLeavePrompt } from "@assets/hooks";
import { CommonTypes } from "@assets/types";

type LeavePageModalProps = {
  isDirty?: boolean;
  isLink?: boolean;
  onLeave: CommonTypes.CallbackFunction;
};

const LeavePageModal = ({
  onLeave,
  isLink = false,
  isDirty = true,
}: LeavePageModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  useLeavePrompt(isDirty);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleLeave = () => {
    onLeave();
    closeModal();
  };

  return (
    <>
      {isLink ? (
        <Button
          id="leave-page"
          onClick={isDirty ? openModal : onLeave}
          variant="text"
        >
          {t("LABEL_CANCEL")}
        </Button>
      ) : (
        <Button
          id="leave-page"
          onClick={isDirty ? openModal : onLeave}
          variant="secondary"
        >
          {t("LABEL_CANCEL")}
        </Button>
      )}
      <Modal
        closeIcon
        closeOnOutsideClick
        divided
        onClose={closeModal}
        open={isModalOpen}
        primaryButtonProps={{
          children: t("LABEL_DISCARD"),
          id: "discard-changes",
          onClick: handleLeave,
        }}
        secondaryButtonProps={{
          children: t("LABEL_CANCEL"),
          id: "cancel-leave",
          onClick: closeModal,
        }}
        size="medium"
        title={t("LABEL_DISCARD_UNSAVED_CHANGES")}
      >
        {t("TEXT_LEAVE_PAGE")}
      </Modal>
    </>
  );
};

export default LeavePageModal;
